<div class="flex flex-row h-[72px] w-full shrink-0 shadow-full">


  <!--  &lt;!&ndash; Left arrow &ndash;&gt;-->
  <!--  <div class="flex flex-col h-full justify-center items-center hover:bg-gray-200 rounded-r-md">-->
  <!--    <button cdkStepperPrevious class="px-4">-->
  <!--      <fa-icon class="text-blue text-2xl" [icon]="faChevronLeft"></fa-icon>-->
<!--    </button>-->
<!--  </div>-->

  <!-- Back Button -->
  <div [ngClass]="{'hover:bg-gray-200 rounded-l-md': previousStepAllowed}"
       class="flex flex-col h-full justify-center items-center text-blue">
    <button [disabled]="this.selectedIndex === 0 || isCheckView && this.selectedIndex === steps.length-1 || !previousStepAllowed" cdkStepperPrevious
            class="px-4">
      <fa-icon [icon]="faChevronLeft"
               [ngClass]="selectedIndex === 0 ? 'text-white' : isCheckView && selectedIndex === steps.length-1 ? 'text-gray-500 opacity-50' : 'text-gray'"
               class="text-[24px]"></fa-icon>
    </button>
  </div>


  <!-- Stepper content -->
  <div class="flex flex-row px-4 gap-8 justify-between items-center w-full h-full">
    @for (_ of Array(steps.length * 2 - 1); track $index; let i = $index) {
      <!-- Step index and label -->
      @if (i % 2 === 0) {
        <div class="flex flex-row w-min h-full justify-center items-center"
             [class]="steps.length < 3 ? 'mx-40' : 'mx-0'">
          <button (click)="onClick(i/2)"
                  class="flex flex-row w-min h-full justify-center py-6 gap-2.5 align-center text-center text-blue whitespace-nowrap font-medium"
                  [tooltip]="stepTooltips[i / 2]"
                  [attr.aria-disabled]="!isStepEnabled(i / 2)"
                  [class]="(steps.get(i/2)?.completed || selectedIndex === i/2 || steps.get((i/2)-1)?.completed) && steps.get(i/2)?.editable ? 'hover:opacity-50' : 'hover:cursor-default'">
            <!-- Index -->
            <div class="flex-none flex-row h-6 w-6 rounded-full justify-center items-center"
                 [ngClass]="{'border-bic-dark-gray border': selectedIndex !== i/2 && !steps.get(i/2)?.completed,
                                  'bg-green': selectedIndex === i/2,
                                  'bg-blue': selectedIndex !== i/2 && steps.get(i/2)?.completed}">
              <div class="flex flex-row justify-center items-center"
                   [class]="selectedIndex !== i/2 && !steps.get(i/2)?.completed ? 'text-bic-dark-gray' : 'text-white'">
              <span [class]="i === 0 ? 'pt-1' : 'pt-[3px]'" [ngClass]="{'pr-0.5': i === 0 || i === 6}"
                    class="leading-none">
              {{ i / 2 + 1 }}</span>
              </div>
            </div>
            <!-- Label -->
            <div class="inline-flex"
                 [ngClass]="{'text-bic-dark-gray': selectedIndex !== i/2 && !steps.get(i/2)?.completed,
                                  'text-green': selectedIndex === i/2,
                                  'text-blue': selectedIndex !== i/2 && steps.get(i/2)?.completed}">
              {{ steps.get(i / 2)?.label }}
            </div>
          </button>
        </div>
      }
      <!-- Connector line -->
      @if (i % 2 !== 0) {
      <div class="flex h-0 w-full border border-bic-gray"></div>
      }
    }
  </div>


  <!-- Right arrow -->
  <div [ngClass]="{'hover:bg-gray-200 rounded-l-md': nextStepAllowed}"
       class="flex flex-col h-full justify-center items-center text-blue">
    <button cdkStepperNext class="px-4" [disabled]="!nextStepAllowed || this.selectedIndex == this.steps.length -1">
      <fa-icon [icon]="faChevronRight"
               [ngClass]="selectedIndex === steps.length-1 ? 'text-white' : isCheckView && selectedIndex === 0 ? 'text-gray-500 opacity-50' : 'text-gray'"
               class="text-[24px]"></fa-icon>
    </button>
  </div>


</div>
